import { Article } from './models/article.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RootService } from 'src/app/services/root/root.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.scss']
})

export class StockComponent implements OnInit {
  filteredResults: Article[];
  dataSource = new MatTableDataSource<Article[]>();
  displayedColumns: string[] = ['codigo', 'descripcion', 'stock', 'ingreso', 'egreso'];
  spinner: boolean = false;
  alertMessage: boolean = false;
  constructor(private rootService: RootService) { }

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
    this.dataSource.sort = this.sort;
  }

  onSubmit(item: any) {

    if (item.length >= 3) {

      this.spinner = true;

      return this.rootService.getItems(item).subscribe((response) => {
        if(response["ttbusqueda"] == '') {
          this.spinner = false;
          this.alertMessage = true;
        } else {
          this.filteredResults = response["ttbusqueda"];
          this.spinner = false;
          this.alertMessage = false;
        }

      }, err => {
        this.alertMessage = true;
        this.spinner = false;
      })
    }
  }

  onSelect(item): void {
    this.dataSource.data.push(item);
    this.dataSource.data = this.dataSource.data.slice();
  }

  clearSearch() {
    return this.filteredResults = [];
  }

  clearSelection() {
    return this.dataSource.data = [];
  }
}
